import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reset } from 'redux-form';
import { loadParentsNotChooseCenter } from './actions';
import List from './List';
import Filter from './Filter';

class ParentsNotChooseCenter extends Component {
	constructor(props) {
		super(props);
		this.handleFilterSubmit = this.handleFilterSubmit.bind(this);
		this.handleListEvent = this.handleListEvent.bind(this);
	}

	componentDidMount() {
		const { filter, sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber, pageSize });
	}

	loadData({ filter, sortKey, sortDirection, pageNumber, pageSize }) {
		this.props.loadEntities({...filter, sortKey, sortDirection, pageSize, pageNumber});
	}

	handleFilterSubmit(filter) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.loadData({ filter, sortKey, sortDirection, pageNumber: 1, pageSize });
	}

	handleListEvent(listPagination) {
		const { filter } = this.props.pagination;
		this.loadData({ filter, ...listPagination });
	}

	render() {
		const { filter } = this.props.pagination;
		return (
			<div>
				<Filter onSubmit={this.handleFilterSubmit} initialValues={filter} loading={this.props.pagination.loading}/>
				<List data={this.props.data} onFetchData={this.handleListEvent} {...this.props.pagination} />
			</div>
		);
	}
}

const mapStateToProps = state => {
	const {
		pagination,
		entities: { parentsNotChooseCenter }
	} = state;

	const parenstNotChooseCenterPagination = pagination.parentsNotChooseCenter.all || { ids: [], pageNumber: 1, pageSize: 10 };

	return {
		data: parenstNotChooseCenterPagination.ids.map(id => parentsNotChooseCenter[id]),
		pagination: parenstNotChooseCenterPagination,
	};
};

export default connect(mapStateToProps, {
	loadEntities: loadParentsNotChooseCenter,
	resetFilter: () => reset('parentsNotChooseCenterFilter')
})(ParentsNotChooseCenter);